import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { LazyLoadEvent, MenuItem } from 'primeng/primeng';
import { OrderService } from '../../services/index';
import { Order } from '../../models/index';

import * as globals from '../../../shared/globals';

@Component({
  selector: 'app-order-table',
  templateUrl: './order-table.component.html',
  styleUrls: ['./order-table.component.scss'],
  animations: []
})
export class OrderTableComponent implements OnInit {
	// @Input('company') companyId: number;
	// @Input('contact') contactId: number;
    // @Input('orderCompleted') orderCompleted: boolean;
    @Input('filters') filters: any = {};

    _filters = {
        status: {
            value: 'all'
        }
    };

	orders: Array<Order> = [];
	totalOrders: number = 0;

	showLoadingError: boolean = false;
	loadingOrders: boolean = false;

	globals = globals;

	lastEvent: LazyLoadEvent;

	selectedOrder: Order;
	cmItems: MenuItem[];

	constructor(
		private router: Router,
		private translate: TranslateService,
		private orderService: OrderService
	) {}

	ngOnInit()
	{
		/* this.translate.get(['View', 'Delete']).subscribe(res => {
	        this.cmItems = [
	            {label: res['View'], icon: 'fa-search', command: (event) => this.router.navigate(['/order', this.selectedOrder.id])},
	            {label: res['Delete'], icon: 'fa-close', command: (event) => this.removeOrder(this.selectedOrder)}
			];
		}); */
    }
    
    ngOnChanges(changes: SimpleChanges) {

        
        if (changes.filters) {
            if (this.lastEvent) {
                this.lastEvent.filters = {};
            }
            this._filters = changes.filters.currentValue;
            this.loadOrders();
        }

		/*if(changes.options) {
			this._options = changes.options.currentValue;
		}

		if(changes.iValue) {
            this.setSelected(changes.iValue.currentValue);			
		}

		if(changes.filterOn) {
			this._options = this.options.filter(v => (!v.filterable || v.filterable == changes.filterOn.currentValue));

			this.selected = this._options.filter(v => v.value == this.iValue)[0];
			this.lastSelected = this.selected;
		}*/

	}

	loadOrders(event?: LazyLoadEvent)
	{
		if(!event) {
			event = this.lastEvent;
		}

		if(!event) {
			this.showLoadingError = true;
			return;
		}

        event.filters = { ...this._filters, ...event.filters };

		this.lastEvent = event;

		this.orderService.getLazy(event).subscribe(data => {
			this.orders = data.data;
			this.totalOrders = data.total;

			this.showLoadingError = false;
			this.loadingOrders = false;
		}, err => {
			this.showLoadingError = true;
			this.loadingOrders = false;
		});
	}
    
    onRowDblclick(event: any) {
        this.openOrder(event.data.id);
    }
    
    openOrder(id: number) {
        this.router.navigate(['/shop/order', id]);
    }
  
    removeOrder(id: number)
    {
        this.orderService.delete(id).subscribe((data) => {
			this.loadOrders();
        });
    }
  
    restoreOrder(id: number)
    {
        this.orderService.restore(id).subscribe((data) => {
			this.loadOrders();
        });
    }

	isUndefined(val) { return typeof val === 'undefined'; }
}



// WEBPACK FOOTER //
// /var/www/vhosts/vinologiwijnen.nl/httpdocs/crm/resources/assets/src/app/shared/modules/order-table/order-table.component.ts